import React from 'react';
import { Field, FieldProps } from 'formik';

import { TextArea } from '../inputs';
import { Props as TextAreaProps } from '../inputs/TextArea';

const CustomField = ({ field, form, ...props }: FieldProps<TextAreaProps>) => <TextArea {...field} {...props} />;

const FormTextArea = (props: Partial<TextAreaProps>) => <Field {...props} component={CustomField} />;

export default FormTextArea;
